import { APICore } from "./apiCore";

const api = new APICore();

const getTipoAtendimentos = (queryString?: string) => {
  return api.get(`/tipo-atendimento${queryString ? queryString : ""}`);
};

export { getTipoAtendimentos };
